export enum PaybackMethod {
  PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
  MONTHLY_PAYMENT = 'MONTHLY_PAYMENT',
}

export const PaybackMethods = [
  { value: 'MONTHLY_PAYMENT', label: 'Gesamtbetrag einmal im Monat' },
  { value: 'PARTIAL_PAYMENT', label: 'Monatliche Teilbeträge' },
];
